import { css } from '@emotion/css'

import { mediaQueryHelper, borderRadius, breakpoint, fontSize, fontWeight } from '@offerzen/pinata-shame'

import colors from '../../lib/themes/colors'

const styles = {
  button: css({
    height: 48,
    width: '100%',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    borderRadius: borderRadius.default,
    border: '#000 1px solid',
    transition: 'box-shadow .3s ease-out',
    fontWeight: fontWeight.medium,
    fontSize: fontSize.default,

    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      height: 40,
      fontWeight: fontWeight.regular,
    },
  }),

  providerLogoContainer: css({
    position: 'relative',
    width: 48,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.phone)]: {
      width: 40,
    },
  }),

  logo: css({
    margin: 'auto',
  }),

  name: css({
    display: 'flex',
    margin: 'auto',
  }),
}

export const providerTheme = provider => {
  switch (provider) {
    case 'google':
      return css({
        color: colors.white,
        backgroundColor: '#4285F4',
        borderColor: '#4285F4',
        '&:hover': {
          boxShadow: '0px 0px 5px 2px rgba(66, 133, 244, 0.3)',
        },
      })
    case 'linkedin':
      return css({
        color: colors.white,
        backgroundColor: '#007BB6',
        borderColor: '#007BB6',
        '&:hover': {
          boxShadow: '0px 0px 5px 2px rgba(0, 123, 182, 0.3)',
        },
      })
    case 'github':
      return css({
        color: colors.white,
        backgroundColor: colors.black,
        borderColor: colors.black,
        '&:hover': {
          boxShadow: '0px 0px 5px 2px rgba(0, 0, 0, 0.3)',
        },
      })
    default:
  }
}

export const providerLogoTheme = provider => {
  switch (provider) {
    case 'google':
      return css({
        backgroundColor: colors.white,
        borderTopLeftRadius: borderRadius.small,
        borderBottomLeftRadius: borderRadius.small,
        '& img': {
          height: 18,

          [mediaQueryHelper(breakpoint.phone)]: {
            height: 15,
          },
        },
      })
    case 'linkedin':
      return css({
        backgroundColor: '#007BB6',
        borderRight: '1px solid rgba(25, 23, 23, 0.2)',
        '& img': {
          height: 18,

          [mediaQueryHelper(breakpoint.phone)]: {
            height: 15,
          },
        },
      })
    case 'github':
      return css({
        backgroundColor: colors.black,
        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
        '& img': {
          height: 22,

          [mediaQueryHelper(breakpoint.phone)]: {
            height: 19,
          },
        },
      })
    default:
  }
}

export default styles
